// extracted by mini-css-extract-plugin
export default {"input":"input-name_input__QRkta","input__outer":"input-name_input__outer__eiPsH","input__half":"input-name_input__half__oILMw"};